import { useEffect, useState } from "react";
import { CrudFilters, LogicalFilter } from "@refinedev/core";
import { useSelectedStores } from "@/config/context/SelectedItemsContext";
import { axiosInstance } from "@/utilities";
import { API_URL_STORES } from "@/services/XCONS_ENV";

interface UseStoreFiltersProps {
  field?: string;
  operator?: any;
  setFilters: (filters: CrudFilters) => void;
  extraFilters?: LogicalFilter[];
}

export const useStoreFilters = ({
  field = "store.code",
  operator = "in",
  setFilters,
  extraFilters = [],
}: UseStoreFiltersProps) => {
  const { selectedStores } = useSelectedStores();

  useEffect(() => {
    const selectedCodes = selectedStores.map((store) => store.code);
    const baseFilter: LogicalFilter[] =
    selectedCodes.length > 0
      ? [
          {
            field,
            operator,
            value: selectedCodes,
          },
        ]
      : [];

    setFilters([...baseFilter, ...extraFilters]);

    if (selectedCodes.length === 0) {
      setFilters([{
            field,
            operator,
            value: undefined,
          }]);
    
    }
  }, [selectedStores]);
};